import { useState } from "react";
// import OrderHistoryBoard from "../OrderHistoryBoard";
import OrderHistoryDedicated from "./Dedicated/OrderHistoryDedicated";
import useDecodeToken from "../../hooks/useDecodeToken";
import {
  hasAccessToDedicated,
  hasAccessToNetwork,
} from "../../services/accountService";
// import OrderHistoryPage from "./OrderHistoryPage";
import NewOrderHistoryPage from "./NewOrderHistoryPage";

function OrderHistoryMode() {
  const [decodeToken] = useDecodeToken();

  const [orderHistoryMode, setOrderHistoryMode] = useState(() => {
    if (!decodeToken) return "network"; // Default to "network" if no decodeToken
    // const { IsDedicatedClient, IsNetworkClient } = decodeToken || {};
    // If the client is both dedicated and network, default to "network"
    if (hasAccessToDedicated(decodeToken) && !hasAccessToNetwork(decodeToken)) {
      return "dedicated";
    }

    return "network"; // Fallback to "network" if no specific condition is met
  });

  if (orderHistoryMode === "network") {
    return (
      <div className="tw-transition-all">
        <NewOrderHistoryPage
          mode={orderHistoryMode}
          onChangeMode={setOrderHistoryMode}
        />
      </div>
    );
  }

  if (orderHistoryMode === "dedicated") {
    return (
      <div className="tw-transition-all">
        <OrderHistoryDedicated
          mode={orderHistoryMode}
          onChangeMode={setOrderHistoryMode}
        />
      </div>
    );
  }

  return null;
}

export default OrderHistoryMode;
